/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PriceListApiModel { 
    id: number;
    name: string;
    validityStart: string;
    validityEnd?: string | null;
    employerId: number;
}

